import React from 'react';
import { useSelector } from 'react-redux';

import PageItem from '../PageItem';
import { getIsContributorOrAdmin } from '../../../../../bundles/auth';
import { getActiveSite } from '../../../../../bundles/sites';

const PageList = ({ pages, updatePages, selectPage, duplicatePages }) => {
  const site = useSelector(getActiveSite);
  const isContributorOrAdmin = useSelector((state) => getIsContributorOrAdmin(state, site));

  const movePage = (from, to) => {
    updatePages((existingPages) => {
      if (to >= 0 && to < existingPages.length) {
        let updatedPages = [...existingPages];
        const [fromElement] = updatedPages.splice(from, 1);
        updatedPages.splice(to, 0, fromElement);

        updatedPages = updatedPages.map((page, index) => ({
          ...page,
          pageIndex: index,
        }));

        return updatedPages;
      }
      return existingPages;
    });
  };

  return (
    <div className="page-list-component">
      {pages.map((page, index) => {
        const key = `${page.id}-${index}`;
        return (
          (isContributorOrAdmin || page.isPublic) && (
            <PageItem
              index={index}
              {...page}
              key={key}
              pageCount={pages.length}
              movePage={movePage}
              selectPage={selectPage}
              pages={pages}
              duplicatePages={duplicatePages}
            />
          )
        );
      })}
    </div>
  );
};

export default PageList;
